namespace Areas.CollaborationAreas {
    "use strict";

    export function gotoCollaborationAreas() {
        location.href = "/CollaborationAreas/List/Index";
    }

    export function gotoProjectFromForm() {
        const projectKeyId: any = Areas.getOptionFromForm("CollaborationAreasForm", "ProjectKeyId");

        if (projectKeyId != null) {
            location.href = `/Projects/View/Index/${projectKeyId}`;
        }
    }

    export function gotoCreate() {
        gotoSelected("CollaborationAreasGrid", "/CollaborationAreas/Create/Index/");
    }

    export function gotoEdit() {
        gotoSelected("CollaborationAreasGrid", "/CollaborationAreas/Edit/Index/");
    }

    const viewUrl = "/CollaborationAreas/View/Index/";
    
    export function gotoView() {
        gotoSelected("CollaborationAreasGrid", viewUrl);
    }

    export function viewLink(cellElement, cellInfo) {
        buildCellContent(cellElement, () => { return cellInfo.data.collaborationAreaId; },
            `<a href= '${viewUrl}{placeholder}'>View</a>`);
    }

    export function sendUserEmail() {
        const dataGrid = Areas.getGrid("CollaborationAreaUsersGrid");
        const dataId = dataGrid.getSelectedRowKeys()[0];

        if (dataId != null) {
            const url = `/CollaborationAreas/Users/ProcessUserEmail/${dataId}`;
            Areas.sendRequest(url, null, "GET");
        } else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }
}



